import { axiosInstance as axios } from "services";

export const addSubCrewsPersonel = async (body) => {
  const { data } = await axios.post("/supplier/addsubcrewsPersonel", body);
  if (!data.success) throw new Error(data.error || "Failed to add sub crews personel");
  return data;
};

